import React from 'react'
import styled from 'styled-components'

import Column from './Column'

import { ExploreState } from 'clientPages/explore/types'
import { ResourceGroup } from 'dataHooks/useExploreResources'
import device from 'utilities/device'

interface ColumnsContainerProps {
  expanded: boolean
}
const ColumnsContainer = styled.section<ColumnsContainerProps>`
  display: flex;
  gap: 36px;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 2rem;
  margin-bottom: 10vw;
  flex-direction: row;
  @media (max-width: 1280px) {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    ${props => props.expanded && 'grid-template-columns: 1fr;'}
  }
  @media ${device.laptop} {
    grid-template-columns: 1fr 1fr;
    ${props => props.expanded && 'grid-template-columns: 1fr;'}
  }
  @media ${device.mobileL} {
    grid-template-columns: 1fr;
  }
`

interface ColumnSectionProps {
  exploreState: ExploreState
  setExploreState: React.Dispatch<React.SetStateAction<ExploreState>>
  resources: ResourceGroup[]
}

const ColumnSection: React.FC<ColumnSectionProps> = ({
  resources,
  exploreState,
  setExploreState,
}) => {
  const handleExpandColumn = (column: string | undefined) => {
    setExploreState(prev => {
      if (column) return { ...prev, type: column }
      const { type: _, ...newState } = prev
      return newState
    })
  }

  const typeActive = exploreState.type !== undefined
  const displayResources = typeActive
    ? resources.filter(r => r.fieldValue === exploreState.type)
    : resources
  return (
    <ColumnsContainer expanded={typeActive}>
      {displayResources.map(group => (
        <Column
          key={group.fieldValue}
          name={group.fieldValue}
          resources={group}
          expand={group.fieldValue === exploreState.type}
          setExpandColumn={handleExpandColumn}
        />
      ))}
    </ColumnsContainer>
  )
}

export default ColumnSection
